export default __webpack_public_path__ + "static/designsprint-c4babffe0a4ed0be5fb77b19e5ab7016.jpg";